import { locales } from '@/state/Locale';

export const pathNameHasNoLocale = (pathName: string) =>
  locales.every(
    (locale) => !pathName.startsWith(`/${locale}/`) && pathName !== `/${locale}`
  );

export const resolveHref = (currentPathName: string, href: string) => {
  if (pathNameHasNoLocale(currentPathName)) {
    return href;
  }

  return `/${currentPathName.split('/')[1]}${href}`;
};
